'use client'
import '@dynamic-labs/sdk-api-core';
import '../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import 'react';
import '@dynamic-labs/wallet-book';
import { AUTH_EXPIRES_AT } from '../../constants/localStorage.js';
import '../../constants/colors.js';
import '../../constants/values.js';
import { LocalStorage } from '../../../shared/utils/classes/storage/localStorage.js';
import '../../../shared/utils/classes/storage/sessionStorage.js';
import '@dynamic-labs/utils';
import '../../../shared/consts/index.js';

const getExpiresAt = () => LocalStorage.getFromLS(AUTH_EXPIRES_AT);

export { getExpiresAt };
